import useResourceStore from '@/stores/resource'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

export const useConsent = () => {
  const EXCLUDE_CHECKBOX_ID = 100

  const resourceStore = useResourceStore()

  const { getConsents: getConsent } = storeToRefs(resourceStore)

  const getConsentFieldset = computed(() => getConsent.value?.fieldsets)

  const getConsentFields = computed(
    () => getConsentFieldset.value?.find((array: any) => array.name === 'consents')?.fields ?? []
  )

  const getConsentCheckboxes = computed(() =>
    getConsentFields.value?.filter((array: any) => array.type === 'checkbox')
  )

  const getConsentText = computed(() =>
    getConsentFields.value?.filter((array: any) => array.type === 'text')
  )

  function getConsentTextExclude(name: string | number) {
    return getConsentText.value?.filter((array: any) => array.name !== String(name))
  }

  function getConsentTextByName(name: string | number) {
    return getConsentText.value?.find((array: any) => array.name !== String(name))
  }

  function getConsentCheckboxExclude(name: string | number) {
    return getConsentCheckboxes.value?.filter((array: any) => array.name !== String(name))
  }

  return {
    getConsent,
    getConsentFieldset,
    getConsentFields,
    getConsentCheckboxes,
    getConsentText,
    getConsentTextExclude,
    getConsentTextByName,
    getConsentCheckboxExclude,
    EXCLUDE_CHECKBOX_ID
  }
}
